<template>
    <section class="order-update container-fluid background-white text-black">
        <article class="row">
            <div class="col-md-12">
                <order-header title="Shopify Order Edit"/>
            </div>
        </article>
        <article class="row">
            <div class="col-md-12">
                <order-id v-on:fetchOrder="fetchOrder"
                          :region.sync="regionSelected"
                          :orderPo.sync="orderPoSelected"
                          :orderNum="orderNum"
                          :d365Id="d365Id"
                          :disabled="isPreloaded"
                          :isLoading="isLoading"
                          :hideButton = "hideButton"/>
            </div>
        </article>
        <article class="row">
            <div class="col-md-12">
                <order-tags :tags="tags"/>
            </div>
        </article>
        <hr>
        <article class="row">
            <div class="col-md-12">
                <router-view/>
            </div>
        </article>

      <LockedDialog :lockKey="lockKey" />
    </section>
</template>

<script>
  import {mapActions, mapGetters, mapState, mapMutations} from 'vuex';
  import OrderId from '../Shared/OrderId';
  import OrderTags from '../Shared/OrderTags';
  import OrderHeader from '../Shared/OrderHeader';
  import LockedDialog from '../Shared/LockedDialog';
  import {
    ORDER_INIT,
    ORDER_SET_REGION,
    ORDER_SET_ID,
    ORDER_GET_TAGS,
    ORDER_RESET,
  } from '../../../store/types';
  import { keyify, hasLock } from '../../../store/modules/locks';
  import * as errors from '../../../lang/en/notify';
  import {notify} from '../../../utils';


  export default {
    name: 'OrderPageWrapper',
    components: {
      LockedDialog,
      OrderHeader,
      OrderId,
      OrderTags,
    },
    computed: {
      ...mapState({
        storeState: state => state.order.state,
        isLoading: state => state.order.loading,
        region: state => state.order.region,
        orderPo: state => state.order.id,
        orderNum: state => state.order.order ? state.order.order.name : null,
        d365Id: state => state.order.order ? state.order.order.d365_id : null,
        hideButton: state =>state.order.hideButton?state.order.hideButton:false,
      }),
      ...mapGetters({
        tags: ORDER_GET_TAGS,
      }),
      regionSelected: {
        set(region) {
          this.setRegion(region);
        },
        get() {
          return this.region;
        },
      },
      orderPoSelected: {
        set(orderId) {
          this.setOrderId(orderId);
        },
        get() {
          return this.orderPo;
        },
      },
      lockKey() {
        if (!this.region || !this.orderPo) {
          return '';
        }

        return keyify([this.region, this.orderPo]);
      },
    },
    methods: {
      ...mapActions({
        fetchOrder: ORDER_INIT,
        reset: ORDER_RESET,
      }),
      ...mapMutations({
        setRegion: ORDER_SET_REGION,
        setOrderId: ORDER_SET_ID,
      }),
      normalizeRouteValue(value) {
        return Array.isArray(value) ? value[0] : value;
      },
      getPreloadedOrder() {
        const orderRegion = this.normalizeRouteValue(this.$route.params.region) ||
            this.normalizeRouteValue(this.$route.query.region);
        const orderId = this.normalizeRouteValue(this.$route.params.id) ||
            this.normalizeRouteValue(this.$route.query.orderPo);

        if (!orderRegion || !orderId) {
          return null;
        }

        return {
          orderId,
          orderRegion: orderRegion.toLowerCase(),
        };
      },
    },
    data() {
      return {
        isPreloaded: false,
      };
    },
    async created() {
      const preloadedOrder = this.getPreloadedOrder();

      if (!preloadedOrder) {
        return;
      }

      const {orderId, orderRegion} = preloadedOrder;

      this.setOrderId(orderId);
      this.setRegion(orderRegion);
      this.isPreloaded = true;

      try {
        await this.fetchOrder({
          id: orderId,
          region: orderRegion,
        });
      } catch (err) {
        if (err.message === errors.LOGON_CANNOT_MODIFY_ORDER_ICU) {
          notify(err.message, 'error');
          return;
        }

        throw err;
      }
    },
    beforeRouteLeave(to, from, next) {
      this.reset();
      next();
    }
  };
</script>
